import { render, staticRenderFns } from "./newIndex.vue?vue&type=template&id=4f959f18&scoped=true"
import script from "./newIndex.vue?vue&type=script&lang=js"
export * from "./newIndex.vue?vue&type=script&lang=js"
import style0 from "./newIndex.vue?vue&type=style&index=0&id=4f959f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f959f18",
  null
  
)

export default component.exports